import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

/**
 *
 * @param root0
 * @param root0.value
 */
function RenderDateToRelativeText({ value }) {
    if (!value) {
        return null;
    }
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage;
    const luxonDate = DateTime.fromISO(value, { locale: lang });

    return (
        <div className='text-center'>
            {
                luxonDate.toRelative()
            }
        </div>
    );
}

RenderDateToRelativeText.propTypes = {
    value: PropTypes.string
};

export default RenderDateToRelativeText;